/*=========================================================================================
  File Name: moduleSpaceState.js
  Description: Space Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ActiveOnlineTest: {
      title:'준비된 시험이 없습니다',
      detail:'detail',
      id:0,
      start_time:''
  },
  onlineTests: [],
  onlineTestSearchQuery: '',
  onlineTestMembers:[],
}
